<template>
  <div class="smartvoiceList">
    <div v-for="item in list"
      :key="item.groupId"
      @click="setItem(item.groupId)"
      class="item"
      :class="{active: item.groupId === active}">
      {{item.groupName}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'SmartVoiceList',
  props: [
    'locale',
    'list',
    'active'
  ],
  mounted () {
  },
  data () {
    return {
    }
  },
  methods: {
    setItem (groupId) {
      this.$emit('setItem', groupId)
    }
  }
}
</script>
